export default {
    shared: {
        noCategory: 'No category',
        addQuestion: 'Add question',
    },
    index: {
        title: 'FAQ',
        description: 'Questions grouped into categories. Each category gets its own page at {path}, and every question keeps a permanent link of its own, so an answer can be pointed at directly.',
        defaultLocale: '(default)',
        localeNote: 'Each language keeps its own questions. Nothing is copied between them.',
        newCategory: 'New category',
        newCategoryPlaceholder: 'Shipping',
        categories: 'Categories',
        noCategories: 'No categories in this language. Questions can be written without one.',
        noQuestionsHidden: 'No questions yet: not shown on the site',
        unpublishedHidden: 'Unpublished: not shown on the site',
        deleteCategory: 'Delete category',
        confirmDeleteCategory: 'Delete “{name}”? | Delete “{name}”? Its {n} question will move to “No category” and show on the FAQ index. | Delete “{name}”? Its {n} questions will move to “No category” and show on the FAQ index.',
        confirmDeleteQuestion: 'Delete “{question}”?',
        uncategorisedNote: 'These questions have no category and render straight on the FAQ index.',
        intro: 'Intro',
        introHint: 'Optional sentence above the questions. Plain text.',
        publishedHint: 'Unpublishing hides the category and every question in it.',
        emptyUncategorised: 'No loose questions. Add one here and it shows on the FAQ index without needing a category.',
        emptyCategory: 'No questions in this category yet. A category with nothing published in it is left off the site entirely.',
        pickCategory: 'Pick a category, or add one, to start writing questions.',
    },
    dialog: {
        newTitle: 'New question',
        editTitle: 'Edit question',
        question: 'Question',
        questionPlaceholder: 'How long does delivery take?',
        questionHint: 'Write it the way a visitor would ask it, not as keywords.',
        category: 'Category',
        categoryHint: 'Optional. Without one the question shows on the FAQ index.',
        answer: 'Answer',
        answerNote: 'Write an answer that stands on its own. Search engines and AI assistants quote one question and answer at a time, lifted out of the page, so “as mentioned above” means nothing to the person reading it.',
        publishNote: 'A question cannot be published while its answer is empty. Save it unpublished to keep drafting.',
        showAnchor: 'Show the link anchor',
        hideAnchor: 'Hide the link anchor',
        anchor: 'Anchor',
        anchorNote: 'Links people have already shared point at {anchor}. Changing this breaks them, so rewording a question leaves it alone on purpose.',
    },
};
